import FormInterlocks from "../FormInterlocks/FormInterlocks";
import { useLocation, useParams } from "react-router-dom";
import "./CadastroInterlocks.css";
import { useEffect, useState } from "react";
import CadastroContainer from "../../../components/CadastroContainer/CadastroContainer";
import InterlockService from "../../../services/InterlockService";

const CadastroInterlocks = () => {
	const { interlockId } = useParams();
	const { state } = useLocation();
	const [interlock, setInterlock] = useState(state);
	const [type, setType] = useState("");

	async function loadInterlock(id) {
		const response = await InterlockService.getOneUuid(id);
		if (response.data) {
			setInterlock(response.data);
		}
	}

	useEffect(() => {
		setType(interlockId || state ? "edicao" : "cadastro");
		if (state) {
			setInterlock(state);
			return;
		}

		if (interlockId) {
			loadInterlock(interlockId);
		}
	}, [state, interlockId]);

	return (
		<CadastroContainer>
			<FormInterlocks interlock={interlock} type={type} />
		</CadastroContainer>
	);
};

export default CadastroInterlocks;
